"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _ChildTab = _interopRequireDefault(require("./ChildTab"));
var _SidenavDivider = _interopRequireDefault(require("./SidenavDivider"));
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    header: {
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(7)
    },
    root: {
      paddingBottom: theme.spacing(1)
    },
    typography: {
      color: theme.palette.common.white,
      opacity: 0.5
    }
  };
});
var Subsection = function Subsection(props) {
  var childTabs = props.childTabs,
    header = props.header,
    onClick = props.onClick,
    selectedTab = props.selectedTab,
    focusedTab = props.focusedTab,
    onKeyDown = props.onKeyDown;
  var classes = useStyles();
  var handleOnClick = function handleOnClick(childTab) {
    return function (event) {
      if (childTab.onClick) {
        childTab.onClick(event, childTab.route);
        event.preventDefault();
      } else {
        onClick(event, childTab.route);
      }
    };
  };
  var count = 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    role: "menu"
  }, header && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.typography,
    variant: "overline"
  }, header)), childTabs.map(function (childTab) {
    var isSelected = selectedTab !== null && selectedTab.tabRoute === childTab.route;
    var isFocused = focusedTab !== null && focusedTab.tabRoute === childTab.route;
    return childTab.divider ? /*#__PURE__*/_react["default"].createElement(_SidenavDivider["default"], {
      automationId: childTab.automationid,
      dataMetrics: childTab.dataMetrics,
      key: "child".concat(count++)
    }) : /*#__PURE__*/_react["default"].createElement(_ChildTab["default"], {
      dataMetrics: childTab.dataMetrics,
      isFocused: isFocused,
      isSelected: isSelected,
      key: childTab.text,
      onClick: handleOnClick(childTab),
      onKeyDown: onKeyDown,
      route: childTab.route,
      text: childTab.text
    });
  }));
};
Subsection.propTypes = process.env.NODE_ENV !== "production" ? {
  childTabs: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
    dataMetrics: _propTypes["default"].string,
    divider: _propTypes["default"].bool
  }), _propTypes["default"].shape({
    dataMetrics: _propTypes["default"].string,
    route: _propTypes["default"].string.isRequired,
    text: _propTypes["default"].string.isRequired
  })])),
  focusedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  header: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onKeyDown: _propTypes["default"].func.isRequired,
  selectedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number.isRequired,
    tabRoute: _propTypes["default"].string
  }).isRequired
} : {};
var _default = Subsection;
exports["default"] = _default;